import { render, staticRenderFns } from "./share_email.vue?vue&type=template&id=0771cf8b&scoped=true&v-once=true&"
import script from "./share_email.vue?vue&type=script&lang=js&"
export * from "./share_email.vue?vue&type=script&lang=js&"
import style0 from "./share_email.vue?vue&type=style&index=0&id=0771cf8b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0771cf8b",
  null
  
)

export default component.exports